export const IP = 'http://35.208.56.171/';
export const API = 'ApiGMM/';
export const PATH = IP+API;

export const CAT = 'catalogos/';

export const INTER_CONTRATANE = 'interContratante';
export const TIPO_FLUJO = 'tipoFlujo';
export const INTER_PADECIMIENTOS = 'padecimientos';
export const EXCLUSION_M = 'exclusionMayor';
export const EXCLUSION_E = 'exclusionEmbarazo';


//validaciones
export const VACIO = "";
export const UN_CRITERIO = "Debe proporcionar al menos un crtierio de búsqueda.";
export const VALOR_NECESARIO = "Ingrese un valor";
export const FECHA_VALIDA = "Ingrese una fecha válida";
export const CMB_NECESARIO = "Seleccione una opción válida";
export const VALOR_POSITIVO = "Ingrese un valor positivo";
export const VALOR_NUMERO = "Ingrese un número";
export const VALOR_ENTERO = "Ingrese un número entero";
export const CORREO_INVALIDO = "Ingrese un correo válido";
export const TELEFONO_INVALIDO = "Ingrese un número válido";
export const CP_INVALIDO = "Ingrese un código postal válido";
export const EDAD_INVALIDA = "Ingrese una edad válida";
export const CMB_MENOS_UNO = -1;
export const CMB_NULL = null;
export const EMPTY = "";
export const MIN_LETRAS_DES_AUTO = 3;
export const MAX_LENGTH_CP = 5;
export const CHECK_NECESARIO = "Seleccione una opción";
export const MAX_LENGTH_NUM_TARJETA = 16;
export const MAX_LENGTH_CVV = 4;
export const ERROR_MSG = "Te pedimos una disculpa, hubo un error al realizar tu consulta.";
export const ERROR_TITULO_MSG = "¡Sucedió un Error!";
export const ERROR_MSG_1 = "El número de serie ya esta amparado en otra póliza";
export const ERROR_TITULO_MSG_1 = "Validación de número de serie";
export const MAX_LENGTH_NO_SERIE = 17;
export const MAX_LENGTH_PLACAS = 7;
export const MAX_LENGTH_RFC = 13;
export const MAX_LENGTH_RFC_M = 12;
export const MAYOR_EDAD = "Debe ser mayor de edad";
export const AUTOCOMPLETE = "Debe escribir para buscar su auto";
export const REQUERIDO = "Se requiere aceptar Aviso de Privacidad";

export const initYear = 1980;
export const meses = [{id:1,nombre:'Enero'},
{id:2,nombre:'Febrero'},
{id:3,nombre:'Marzo'},
{id:4,nombre:'Abril'},
{id:5,nombre:'Mayo'},
{id:6,nombre:'Junio'},
{id:7,nombre:'Julio'},
{id:8,nombre:'Agosto'},
{id:9,nombre:'Septiembre'},
{id:10,nombre:'Octubre'},
{id:11,nombre:'Noviembre'},
{id:12,nombre:'Diciembre'}]

/*export const TEXT_MAX = 'Debe tener como máximo ${max} caracteres';
export const TEXT_MIN = 'Debe tener ${min} caracteres';
export const TEXT_MIN_MAX = 'Debe tener ${max} caracteres';*/


export const descripcionTarjetaTipoEventos = "Por favor agrega a cada uno de los accidentes o enfermedades que hayan requerido hospitalización";
export const descripcionTarjetaAdicionales = "Por favor agrega a cada una de las personas que te gustaría asegurar";


/* lista componentes*/
export const BIENVENIDA = "bienvenida";
export const DATOS = "datos";
export const PERSONA_MAYOR = "personaMayor";
export const EMBARAZO = "embarazo";
export const ALGUIEN_MAS = "alguienMas";
export const SOLO_AM = "soloAlguienMas";
export const SOLO_AM_AGREGAR = "soloAlguienMasAgregarMas";

export const MSG030 = "Error interno, por favor notifique a su Administrador de Sistemas.";